import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Welcome from './_pages/Welcome'
import Dashboard from './_pages/Dashboard'
import About from './_pages/About'
import Login from './_pages/Login'
import PrivateRoutes from './_components/PrivateRoutes'
import Signup from './_pages/Signup'
import Companies from './_pages/Companies'
import LinkedIn from './_pages/LinkedIn'

function App() {
  return (
    <Router>
      <Routes>

        <Route  path="/" element={<Welcome />} exact></Route>
        <Route  path="/welcome" element={<Welcome />}></Route>          
        <Route path="/login" element={<Login />}></Route>
        <Route path="/signup" element={<Signup />}></Route>
        <Route element={<PrivateRoutes/>}>
          <Route element={<Dashboard/>} path="/dash"></Route>
          <Route element={<Companies/>} path="/companies"></Route>
          <Route element={<About/>} path="/about"></Route> 
          <Route path="/linkedin" element={<LinkedIn/>}></Route>
        </Route>




        
      </Routes>
    </Router>
  );
}

export default App;
